import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { Button } from 'ui-components/components/button';

import { BulkApplyCheckbox } from '../../../../fulfillment-plans/bulk-apply/bulk-apply-checkbox';
import { useFulfillmentPlanTagsContext, SAVE_TAGS_BUTTON_ID } from './tag-context';

import messages from './messages';
import style from './tags.module.less';

export const BulkFulfillmentPlanTagDropdownFooter = () => {
  const { toggleBulkUpdate, isBulkUpdate, clearTags, saveTags } = useFulfillmentPlanTagsContext();

  return (
    <div className={style['fulfillment-plan-tag-dropdown-footer']}>
      <BulkApplyCheckbox isBulkUpdate={isBulkUpdate} message={messages.bulkUpdateCheckBoxMessage} toggleBulkUpdate={toggleBulkUpdate} />
      <div className={style['fulfillment-plan-tag-dropdown-footer-actions']}>
        <Button className={style['fulfillment-plan-tag-dropdown-footer-action']} onClick={clearTags} theme='link'>
          <FormattedMessage {...messages.clearTags} />
        </Button>
        <Button
          className={classnames(style['fulfillment-plan-tag-dropdown-footer-action'])}
          id={SAVE_TAGS_BUTTON_ID}
          onClick={saveTags}
          theme='primary'
        >
          <FormattedMessage {...messages.saveTags} />
        </Button>
      </div>
    </div>
  );
};
